/* gorilla-qty-selector.js — Quantity +/- controls */
(function () {
  'use strict';

  function initQty(wrap) {
    var input  = wrap.querySelector('.gorilla-qty__input');
    var minus  = wrap.querySelector('[data-qty-minus]');
    var plus   = wrap.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;

    function clamp(val) {
      var min = parseInt(input.min || '1', 10);
      var max = input.max ? parseInt(input.max, 10) : Infinity;
      return Math.min(Math.max(val, min), max);
    }

    minus.addEventListener('click', function (e) {
      e.preventDefault();
      var newVal = clamp((parseInt(input.value, 10) || 1) - 1);
      input.value = newVal;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('qty:change', { detail: { quantity: newVal } }));
    });

    plus.addEventListener('click', function (e) {
      e.preventDefault();
      var newVal = clamp((parseInt(input.value, 10) || 1) + 1);
      input.value = newVal;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      window.dispatchEvent(new CustomEvent('qty:change', { detail: { quantity: newVal } }));
    });

    input.addEventListener('change', function () {
      input.value = clamp(parseInt(input.value, 10) || 1);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-qty-selector]').forEach(initQty);
  });
})();
